module.exports = __webpack_public_path__ + "media/images/bedroom-82ee5a3e2b64beb67ba1ff8961a16cbd.png";